module.exports = __webpack_public_path__ + "img/LogoJanssenSmall.0b43ccbf.png";